"use client";

import { useAppSessionTracker } from "@/lib/useAppSessionTracker";

export default function AppSessionTracker() {
  useAppSessionTracker();
  return null;
}